import React from 'react';
import Logo from '../layout/shared/Logo';
export default function Error404(_ref) {
  var appProps = _ref.appProps,
    classNames = _ref.classNames,
    errorImage = _ref.errorImage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("div", {
    className: "content_wrapper flex-column flex-box items-center content-center"
  }, appProps.preferences.logo && /*#__PURE__*/React.createElement(Logo, {
    appProps: appProps,
    target: '_self',
    classNames: 'header-v1-logo',
    logo: appProps.preferences.logo
  }), /*#__PURE__*/React.createElement("div", {
    className: "text flex-box flex-column content-center items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image"
  }, /*#__PURE__*/React.createElement("img", {
    src: errorImage,
    alt: "404"
  })), /*#__PURE__*/React.createElement("h1", {
    className: "light_text"
  }, "Oh no. Page not found."), /*#__PURE__*/React.createElement("a", {
    className: "button",
    href: "/"
  }, "Back to Homepage")))));
}